//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations, mapActions } from "vuex";
import AlertError from "../components/AlertError.vue"
export default {
  name: "PageResetPassword",
  components: {
    AlertError,
  },
  data() {
    return{
      // copy: loginCopy.loginPage.default,
      copyEndpoint: '/api/userdashboard/getcontent/passwordreset',
      endpoint: '/api/account/sendpasswordresetrequest',
      bodyCopy: {
        heading: 'Password Reset',
        subheading: 'Please verify and re-enter your email',
        inputFieldWatermarkText: 'Email Address',
        submitButtonText: 'Continue',
        cancelButtonText: 'Go Back'
      },
      // formData: {
      //   resetEmail: loginEmail
      // }
      resetPassword: '',
    }
  },
  computed: {
		...mapGetters(["isError", "isDisabled", "resetEmail", "resetPasswordContent", "isLoading"]),
    // resetPassword: {
    //   get() {
    //     return this.resetEmail
    //   },
    //   set(val) {
    //     return this.setResetEmail(val)
    //   }
    // }
  },
	methods: {
		...mapMutations(["setDisabled", "setError", "setResetEmail", "setResetPassword", "setAccountExist", "setLoading"]),
		...mapActions(["submitResetPassword"]),
    processReset(data) {
      data.preventDefault()
      const endpoint = this.endpoint
      // const email = this.resetEmail
      const email = {"email":this.resetPassword}
      // console.log(email)
      // clarify with alan re: responses
      this.setDisabled(true)
      this.setLoading(true)
      this.submitResetPassword({email, endpoint})
    },
    toggleLogin() {
      // e.preventDefault()
      this.setAccountExist(true)
      this.setResetPassword(false)
      this.setDisabled(false)
    },   
  },
  mounted() {
    this.setLoading(true)
    this.setError(false)
    fetch(this.copyEndpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then((response) => response.json())
      .then((data) => {
        this.bodyCopy = Object.assign(data)
        setTimeout(() => {
          this.setLoading(false)
        }, 1000);
      });
  },
};
